import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/**
 * Note: 路由配置项
 *
 * hidden: true                     // 当设置 true 的时候该路由不会再侧边栏出现 如401，login等页面，或者如一些编辑页面/edit/1
 * alwaysShow: true                 // 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
 *                                  // 只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
 *                                  // 若你想不管路由下面的 children 声明的个数都显示你的根路由
 *                                  // 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
 * redirect: noRedirect             // 当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
 * name:'router-name'               // 设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 * query: '{"id": 1, "name": "ry"}' // 访问路由的默认传递参数
 * roles: ['admin', 'common']       // 访问路由的角色权限
 * permissions: ['a:a:a', 'b:b:b']  // 访问路由的菜单权限
 * meta : {
    noCache: true                   // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
    title: 'title'                  // 设置该路由在侧边栏和面包屑中展示的名字
    icon: 'svg-name'                // 设置该路由的图标，对应路径src/assets/icons/svg
    breadcrumb: false               // 如果设置为false，则不会在breadcrumb面包屑中显示
    activeMenu: '/system/user'      // 当路由设置了该属性，则会高亮相对应的侧边栏。
  }
 */

// 公共路由
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect')
      }
    ]
  },
  {
    path: '/404',
    component: () => import('@/views/error/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error/401'),
    hidden: true
  },
  {
    path: '/checkup-home',
    component: () => import('@/views/checkupHome/index.vue'),
    name: 'CheckupHome',
    hidden: true
  },
  {
    path: '',
    // 隐藏首页侧边栏菜单
    // hidden: true,
    component: Layout,
    // 重定向到首页管理
    redirect: '/checkup-home',
    // redirect: 'noRedirect',
    children: [
      {
        path: '/goods',
        component: () => import('@/views/goods/index.vue'),
        name: 'goods'
      }
    ]
  },
  {
    path: '/testCreation',
    component: () => import('@/views/testCreation/index.vue'),
    hidden: true
  },
  {
    path: '/groupQuestion',
    component: () => import('@/views/groupQuestion/index.vue'),
    hidden: true
  },
  {
    path: '/topic',
    component: () => import('@/views/topic/index.vue'),
    hidden: true
  },
  {
    path: '/homework',
    component: () => import('@/views/homework/index.vue'),
    hidden: true
  },
  {
    path: '/errorCorrection',
    component: () => import('@/views/errorCorrection/index.vue'),
    hidden: true
  },
  {
    path: '/collect',
    component: () => import('@/views/collect/index.vue'),
    hidden: true
  },
  {
    path: '/note',
    component: () => import('@/views/note/index.vue'),
    hidden: true
  },
  {
    path: '/artificial',
    component: () => import('@/views/artificial/index.vue'),
    hidden: true
  },
  {
    path: '/medical',
    component: () => import('@/views/medical/index.vue'),
    hidden: true
  },
  {
    path: '/jump',
    component: () => import('@/views/transfer/index.vue'),
    hidden: true
  },
  {
    path: '/download',
    component: () => import('@/views/download/index.vue'),
    hidden: true
  },
  {
    path: '/ycMini',
    component: () => import('@/views/ycMini/index.vue'),
    hidden: true
  },
  {
    path: '/noteDownload',
    component: () => import('@/views/noteDownload/index.vue'),
    hidden: true
  },
  {
    path: '/Alipay',
    component: () => import('@/views/Alipay/index.vue'),
    hidden: true
  },
  {
    path: '/score',
    component: () => import('@/views/score/index.vue'),
    hidden: true
  },
  {
    path: '/agreement',
    component: () => import('@/views/agreement/index'),
    hidden: true
  },
  {
    path: '/clinicalDownload',
    component: () => import('@/views/clinicalDownload/index'),
    hidden: true
  },
  {
    path: '/medicalDownload',
    component: () => import('@/views/medicalDownload/index'),
    hidden: true
  },
  {
    path: '/paper',
    component: () => import('@/views/paper/index'),
    hidden: true
  },
  {
    path: '/wait',
    component: () => import('@/views/wait/index'),
    hidden: true
  },
  {
    path: '/subject',
    component: () => import('@/views/subject/index'),
    hidden: true
  },
  {
    path: '/subjectHomeWork',
    component: () => import('@/views/subjectHomeWork/index'),
    hidden: true
  },
  {
    path: '/subjectErrorCorrection',
    component: () => import('@/views/subjectErrorCorrection/index'),
    hidden: true
  },
  {
    path: '/subjectCollect',
    component: () => import('@/views/subjectCollect/index'),
    hidden: true
  },
  {
    path: '/subjectNote',
    component: () => import('@/views/subjectNote/index'),
    hidden: true
  },
  {
    path: '/subjectGroupQuestion',
    component: () => import('@/views/subjectGroupQuestion/index'),
    hidden: true
  },
  {
    path: '/subjectTestCreation',
    component: () => import('@/views/subjectTestCreation/index'),
    hidden: true
  },
  {
    path: '/classScheduleMain',
    component: () => import('@/views/classSchedule/main'),
    hidden: true
  },
  {
    path: '/classSchedule',
    component: () => import('@/views/classSchedule/index'),
    hidden: true
  },
  {
    path: '/teachProcess',
    component: () => import('@/views/classSchedule/teachProcess'),
    hidden: true
  },
  {
    path: '/teachProcessMain',
    component: () => import('@/views/classSchedule/teachProcessMain'),
    hidden: true
  },
  {
    path: '/teachLearn',
    component: () => import('@/views/teachLearn/index.vue'),
    hidden: true
  },
  {
    path: '/teachLearnCertificate',
    component: () => import('@/views/teachLearn/Certificate.vue'),
    hidden: true
  },
  {
    path: '/clocking',
    component: () => import('@/views/classSchedule/clocking'),
    hidden: true
  },
  {
    path: '/checkStudentEvaluate',
    component: () => import('@/views/classSchedule/checkStudentEvaluate'),
    hidden: true
  },
  {
    path: '/checkStudentNotice',
    component: () => import('@/views/classSchedule/checkStudentNotice'),
    hidden: true
  },
  {
    path: '/checkStudent',
    component: () => import('@/views/classSchedule/checkStudent'),
    hidden: true
  },
  {
    path: '/checkStudentHomework',
    component: () => import('@/views/classSchedule/checkStudentHomework'),
    hidden: true
  },
  {
    path: '/ratingScale',
    component: () => import('@/views/classSchedule/ratingScale'),
    hidden: true
  },
  {
    path: '/courseTopic',
    component: () => import('@/views/courseTopic/index.vue'),
    hidden: true
  },
  {
    path: '/scoreReport',
    component: () => import('@/views/scoreReport/index.vue'),
    hidden: true
  },
  {
    path: '/standing',
    component: () => import('@/views/standing/index.vue'),
    hidden: true
  },
  {
    path: '/questionBank',
    component: () => import('@/views/questionBank/index.vue'),
    hidden: true
  },
  {
    path: '/literature',
    component: () => import('@/views/literature/index.vue'),
    hidden: true
  },
  {
    path: '/knowledgeHome',
    component: () => import('@/views/knowledgeHome/index.vue'),
    hidden: true
  },
  {
    path: '/knowledgeList',
    component: () => import('@/views/knowledgeList/index.vue'),
    hidden: true
  },
  {
    path: '/knowledgeDetails',
    component: () => import('@/views/knowledgeDetails/index.vue'),
    hidden: true
  },
  {
    path: '/collectList',
    component: () => import('@/views/collectList/index.vue'),
    hidden: true
  }
]

// 动态路由，基于用户权限动态去加载
export const dynamicRoutes = []

// 防止连续点击多次路由报错
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'hash', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})
